export enum Region {
  US = "us-east1",
  EU = "eu-west3",
}

export enum MondayRegion {
  US = "use1",
  EU = "euc1",
}

export function getCanvasRegion(region?: MondayRegion | string): Region {
  return region === MondayRegion.EU ? Region.EU : Region.US;
}
